import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import { useSoFormStepsState } from '../../SoForm.context';
import SoFormContainer from '../../components/layout/SoFormContainer';
import { WarningIcon } from 'refactored/ui/icons';
import { useTranslation } from 'react-i18next';

const TempContainer = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;

const SoFormStepPriceError = ({ className }) => {
  const stepsState = useSoFormStepsState();
  const { t } = useTranslation('Catalog');

  const showErrors =
    stepsState.price.showPriceErrors && stepsState.price.errors.hasErrors;

  if (!showErrors) return <></>;

  return (
    <div className={className}>
      <SoFormContainer>
        <TempContainer>
          <WarningIcon />
          {t('price.errors.product_not_selected')}
        </TempContainer>
      </SoFormContainer>
    </div>
  );
};

SoFormStepPriceError.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepPriceError)`
  border-bottom: 4px solid var(--error700);
  background: white;
  width: 100%;
  margin-top: auto;
  text-align: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 12px 16px;
  padding-top: 0;
  color: #263340;
  /* Inside auto layout */

  text-align: center;

  svg {
    fill: var(--error700);
    path {
      fill: var(--error700);
    }
  }
`;
